import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import '../Page.less';
import './MasterBudget.less';

export default function MasterBudget({ subRoutes }) {
  return (
    <section className="page master-budget-page">
      <div className="container">
        <h2>Управление бюджетом</h2>
        <ul className="wrapper">
          {subRoutes.map((route, i) => (
            <li key={i}>
              <NavLink to={route.path}>
                <div className="master-budget-card">
                  <p>{route.title}</p>
                </div>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
